const popup = document.querySelector('state-popup');
const changeStateButton = document.getElementById('change-selection');
const currentLElem= document.getElementById('current-state');
const currentDMElem = document.getElementById('current-delivery-method');

function getPreferredLocation() {
  const stored = localStorage.getItem('preferredLocation');
  if (!stored) return null;

  try {
    const parsed = JSON.parse(stored);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch (error) {
    return null;
  }
}

const preferred = getPreferredLocation();
if (preferred) {
  updateHeaderLocation(preferred.location, preferred.method);
}

function updateHeaderLocation(selectedState = 'Not Selected', selectedDM = 'Not Selected') {
  currentLElem.textContent = `${selectedState}`;
  currentDMElem.textContent = `Method: ${selectedDM}`;
}

if(popup){
  changeStateButton.addEventListener('click', () => {
    popup.checkLocalStorage();
    popup.classList.remove('hide');
  });
}
